import { create } from 'zustand';

/**
 * SSE 실시간 연결 상태(휘발성, 영속화하지 않음). RealtimeEventsProvider가 연결/재연결 상황에 따라
 * 갱신하고, RealtimeStatusBanner가 "unstable"일 때 상단 배너를 띄운다.
 *
 * 운영 SSE 전달이 흔들릴 때 사용자가 "실시간이 지연될 수 있음"을 인지하도록 하는 스톱갭 용도다.
 */
export type RealtimeConnectionStatus = 'connected' | 'unstable';

type RealtimeStatusStore = {
  status: RealtimeConnectionStatus;
  setStatus: (status: RealtimeConnectionStatus) => void;
};

export const useRealtimeStatusStore = create<RealtimeStatusStore>((set) => ({
  status: 'connected',
  setStatus: (status) => set((prev) => (prev.status === status ? prev : { status })),
}));
